import type { LeadFlowStepDefinition } from "../types";

import { getLeadFlowQuestionFieldNames } from "@homeinstead/forms/lead-form";

// The postal question also owns the office pick, and the action reports a
// care type error under one of its `careType.<value>` keys.
function getQuestionFieldName(errorFieldName: string): string {
  if (
    errorFieldName === "location" ||
    errorFieldName === "organizationNumber"
  ) {
    return "postalCode";
  }

  return errorFieldName.split(".")[0] ?? errorFieldName;
}

/**
 * The earliest step asking any field in `errorFieldNames`, so a submit with
 * field errors can send the visitor back to fix them. Returns -1 when
 * no step asks any of them.
 */
function getErrorStepIndex(
  steps: LeadFlowStepDefinition[],
  errorFieldNames: string[],
): number {
  const questionFieldNames = new Set(errorFieldNames.map(getQuestionFieldName));

  return steps.findIndex(
    (step) =>
      step._type === "leadFlowStep" &&
      (step.items ?? []).some((item) =>
        getLeadFlowQuestionFieldNames(item).some((fieldName) =>
          questionFieldNames.has(fieldName),
        ),
      ),
  );
}

export { getErrorStepIndex };
